module.exports = __webpack_public_path__ + "assets/img/character_mercedes.0636a959.png";